import { LogisticShipmentProps } from "./logistic-shipment.type"
import { ShipmentTransactionProps } from "./shipment_transaction.type"
import { TransportCompanyProps } from "./transport-company.type"

export enum ShipmentInvoiceStatusEnum {
  created = 'created',
  request_review = 'request_review',
  pending = 'pending',
  paid = 'paid',
  cancelled = 'cancelled',
}

export enum ShipmentInvoicePaymentPriorityEnum {
  'urgent' = 'urgent',
  'high' = 'high',
  'normal' = 'normal',
  'low' = 'low',
}

export enum ShipmentInvoiceTypeEnum {
  unknown = "unknown",
  first_mile = "first_mile",
  last_mile = "last_mile",
  customs = "customs",
  warehousing = "warehousing",
}

export interface ShipmentInvoiceProps {
  uuid?: string
  transportCompanyUuid?: string
  transportCompany?: TransportCompanyProps
  reference?: string
  value?: string
  currency?: "USD" | "MXN"
  dollarExchangeRate?: string
  invoicePdfFile?: string
  invoiceXmlFile?: string
  invoiceExternalReference?: string
  observation?: string
  expectedPaymentDate?: string
  shipments?: LogisticShipmentProps[]
  shipmentsUuid?: string[]
  transactions?: ShipmentTransactionProps[]
  status?: keyof typeof ShipmentInvoiceStatusEnum
  paymentPriority?: keyof typeof ShipmentInvoicePaymentPriorityEnum
  type?: keyof typeof ShipmentInvoiceTypeEnum
  createdAt?: string
  updatedAt?: string
}

export interface ShipmentInvoiceWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: ShipmentInvoiceProps[]
}